import { formatCurrency } from '@/utils/currency';
import { toTitleCase } from '@/utils/kyc';

export type EntityTypeFilter = 'all' | string;

export const PRODUCT_LABELS_PT: Record<string, string> = {
  pf_basic_data: 'Dados cadastrais básicos',
  pf_lawsuits: 'Processos judiciais',
  pf_lawsuits_predictus: 'Processos judiciais',
  pf_pep: 'PEP e relacionados',
  pf_sanctions: 'Sanções e restrições',
  pf_qsa: 'Relacionamentos econômicos',
  pf_family: 'Relacionamentos pessoais',
  pf_employee: 'Vínculos profissionais',
  pf_email: 'E-mails',
  pf_address: 'Endereços',
  pf_phone: 'Telefones',
  pf_media: 'Mídia e exposição pública',
  pj_receita: 'Dados cadastrais da Receita Federal',
  pj_qsa: 'Quadro societário e relacionamentos',
  pj_lawsuits: 'Processos judiciais',
  pj_lawsuits_predictus: 'Processos judiciais',
  pj_media: 'Mídia e exposição pública',
  pj_certificates: 'Certidões',
  pf_certificates: 'Certidões',
};

export const DATA_SOURCE_LABELS_PT: Record<string, string> = {
  BDC: 'BigDataCorp',
  receita: 'Receita Federal',
};

export const COUNTRY_LABELS_PT: Record<string, string> = {
  br: 'Brasil',
  mx: 'México',
};

export const getProductDisplayName = (slug: string) => {
  const label = PRODUCT_LABELS_PT[slug] || toTitleCase(slug);

  if (slug.startsWith('pf_')) {
    return `${label} (cpf)`;
  }

  if (slug.startsWith('pj_')) {
    return `${label} (cnpj)`;
  }

  return label;
};

export const getDataSourceLabel = (dataSource: string) => {
  return DATA_SOURCE_LABELS_PT[dataSource] || toTitleCase(dataSource);
};

export const getCountryLabel = (countryCode: string) => {
  return COUNTRY_LABELS_PT[countryCode.toLowerCase()] || countryCode.toUpperCase();
};

export const getEntityTypeLabel = (entityType: string) => {
  if (entityType === 'person') return 'Pessoa';
  if (entityType === 'company') return 'Empresa';
  if (entityType === 'lawsuit') return 'Processo';
  return toTitleCase(entityType);
};

export const getEntityTypeSortIndex = (entityType: string) => {
  if (entityType === 'person') return 0;
  if (entityType === 'company') return 1;
  return 2;
};

export const getEntityTypeFilterIcon = (entityType: EntityTypeFilter) => {
  if (entityType === 'all') return 'apps';
  if (entityType === 'person') return 'person';
  if (entityType === 'company') return 'apartment';
  return 'diversity_3';
};

export const getProductIcon = (slug: string, dataSource: string) => {
  if (slug.includes('lawsuits')) return 'gavel';
  if (slug.includes('pep')) return 'workspace_premium';
  if (slug.includes('sanctions')) return 'shield_lock';
  if (slug.includes('media')) return 'newspaper';
  if (slug.includes('address')) return 'location_on';
  if (slug.includes('phone')) return 'call';
  if (slug.includes('email')) return 'alternate_email';
  if (slug.includes('family')) return 'family_restroom';
  if (slug.includes('employee')) return 'badge';
  if (slug.includes('qsa')) return 'account_tree';
  if (slug.includes('basic_data')) return 'assignment_ind';
  if (dataSource.toLowerCase() === 'receita') return 'apartment';
  return 'dataset';
};

export const formatCatalogPriceLabel = (value: number, currency: string) => {
  if (value === 0) {
    return 'Gratuito';
  }

  return formatCurrency(value, currency, false);
};
